/* Copyright 2021 VMware, Inc. All rights reserved. VMware Confidential */
import { Component } from "@angular/core";
import { OAuth2Client } from "@vmw/csp-oauth2";
import { getUser, User } from "@app/services/oauth2/user-util";

// @formatter:off
@Component({
    selector: 'app-error403',
    templateUrl: './error403.component.html'
})
// @formatter:on
export class Error403Component {
    public show403Error: boolean;

    constructor(private oAuth2Client: OAuth2Client) {
        const user: User = getUser(this.oAuth2Client);
        this.show403Error = Boolean(user.orgId);
    }
}
